import { IconTypes } from 'src/app/standalones/components/pencil-icon/pencil-icon.component';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PipeModule } from 'src/app/pipes/pipes.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { BehaviorSubject } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AutocompletePositionDirective } from 'src/app/directives/autocomplete-position.directive';
import { MatInputModule } from '@angular/material/input';
import { PencilIconComponent } from '../pencil-icon/pencil-icon.component';
import { PencilButtonComponent } from '../pencil-button/pencil-button.component';

@UntilDestroy()
@Component({
  selector: 'app-pencil-multi-select-dropdown',
  templateUrl: './pencil-multi-select-dropdown.component.html',
  styleUrls: ['./pencil-multi-select-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    PencilIconComponent,
    PencilButtonComponent,
    TranslateModule,
    PipeModule,
    MatAutocompleteModule,
    MatInputModule,
    AutocompletePositionDirective,
  ],
})
export class PencilMultiSelectDropdownComponent<T extends { [key: string]: any }>
  implements OnChanges
{
  @Input() addableList: T[] = [];
  @Input() hasEditOption = true;
  @Input() valuePropName = 'value';
  @Input() searchBoxHidden = true;

  @Output() searchBoxHiddenChange = new EventEmitter<boolean>();
  @Output() itemSelectedEmitter = new EventEmitter<T>();
  @Output() editOptionClicked = new EventEmitter<void>();

  @ViewChild('userSearch') searchInput!: ElementRef;

  protected IconTypes = IconTypes;

  protected filteredOptions = new BehaviorSubject<T[]>(this.addableList);

  ngOnChanges(changes: SimpleChanges): void {
    // If addableList has changed, update the filtered options
    changes.addableList && this.filteredOptions.next(this.addableList);

    // If searchBoxHidden has changed and is now visible, focus the search input
    changes.searchBoxHidden &&
      !changes.searchBoxHidden.currentValue &&
      setTimeout(() => this.searchInput.nativeElement.focus({ focusVisible: true }), 0);
  }

  selectItem(selectedItem: T): void {
    this.itemSelectedEmitter.emit(selectedItem);
  }

  emitEditOption(): void {
    this.editOptionClicked.emit();
  }

  onSearchQueryChange(value: string): void {
    const filteredTags = this.addableList.filter((item) =>
      item[this.valuePropName].toLowerCase().includes(value.toLowerCase()),
    );
    this.filteredOptions.next(filteredTags);
  }

  blurSearchFocus(): void {
    this.onSearchQueryChange('');
    this.searchBoxHiddenChange.emit(true);
  }
}
